export function selectResourceTypes() {
  return (state) => state.resourceTypes.current;
}